import { FilterProps } from "components/Filters";
import { CheckboxListFilter } from "components/Filters/GenericFilters/CheckboxListFilter";
import { useContractDetailsSelects } from "contexts/ContractDetailsSelectsProvider";
import { sortObjectsByProperty } from "./sortFilterOptions";

export const ContractDetailsModeFilter = ({ variant }: FilterProps) => {
  const selectStates = useContractDetailsSelects();

  const mode = selectStates.find(({ filterKey }) => filterKey === "mode");

  const modeOptions = mode ? sortObjectsByProperty(mode.options, "label") : [];

  return (
    <CheckboxListFilter
      filterKey="mode"
      name="Mode"
      variant={variant}
      filterOptions={modeOptions}
    />
  );
};
